import { cn } from '@/lib/cn';
export function Toggle({ checked, onChange, label }: { checked: boolean; onChange: (v: boolean) => void; label?: string }) {
  return (
    <button role="switch" aria-checked={checked} onClick={() => onChange(!checked)}
      className={cn('inline-flex items-center gap-3 group')}>
      <span className={cn('relative w-11 h-6 rounded-full transition', checked ? 'bg-terre' : 'bg-paper-strong')}>
        <span className={cn('absolute top-0.5 w-5 h-5 rounded-full bg-paper-elev shadow transition-all', checked ? 'left-[22px]' : 'left-0.5')} />
      </span>
      {label ? <span className="t-ui">{label}</span> : null}
    </button>
  );
}
